import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeaderDetails from 'eymp-uicomps/components/HeaderDetails';
import { Grid } from '@material-ui/core';
import { getCaseCountHeader } from 'src/services/cases.service';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { resetCaseToggleOption } from 'src/new-ui/features/NewDashboard/state/newDashboardAction.js';
import { fnGetIsAllDataFlag } from 'src/helpers/commonFunctions';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import { SERVICEINIT_URL_BATCHSI } from 'src/constants/constants';

class EmployeeHeader extends Component {
  state = {
    details: this.getDetails(null),
  };

  fnGetHeaderCount(isAllData) {
    getCaseCountHeader(isAllData).then(resp => {
      this.setState({ details: this.getDetails(resp) });
    });
  }

  componentDidMount() {
    let isAllData = fnGetIsAllDataFlag();
    this.fnGetHeaderCount(isAllData || false);
  }

  componentDidUpdate() {
    if (typeof this.props.newDashboardInfo.isAllCases === 'boolean') {
      this.setState({ details: this.getDetails(null) });
      this.fnGetHeaderCount(this.props.newDashboardInfo.isAllCases);
      this.props.resetCaseToggleOption();
    }
  }

  getDetails(caseCountHeader) {
    const { userDetails, isCorpClient } = this.props;
    return [
      {
        component: (
          <div className="employee-headerInfo">
            <Grid container className="align-items-center">
              {
                <Grid item lg={12} md={12}>
                  <div className="emp-header">
                    <div className="font-regular font-18">Hello {this.props.userInfo.firstName + ' ' + this.props.userInfo.lastName}</div>
                    <div className="d-flex align-items-center spinner-color">
                      <span className="font-regular font-18">
                        {caseCountHeader === null ? <Spinner size={30} /> : caseCountHeader || 0}
                      </span>
                      <span className="font-regular font-12">Cases require your action</span>
                    </div>
                  </div>
                </Grid>
              }
            </Grid>
            {isCorpClient && userDetails && userDetails.serviceInitiationRights ? (
              <div>
                <Button
                  styleType="primary"
                  className="action-button ssi-action-header cursor-pointer"
                  onClick={() => (window.location.href = SERVICEINIT_URL_BATCHSI)}>
                  {intl.get('dashboard.toolbar.button.label')}
                </Button>
              </div>
            ) : null}
          </div>
        ),
      },
    ];
  }

  render() {
    return (
      <div className="header-detail">
        <HeaderDetails details={this.state.details} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.login.userInfo,
    state: state,
    newDashboardInfo: state.newDashboard,
  };
};

const mapDispatchToProps = {
  resetCaseToggleOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeHeader);
